import React from 'react';
import 'animate.css/animate.min.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { CWindowWidth } from 'constants/base.const';
import { Avatar, Tabs, Col, Row, Typography, List } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import MentoringAboutSource1 from 'assets/images/pages/programAbout/mentor_mentoring_about1.webp';
import MentoringAboutSource2 from 'assets/images/pages/programAbout/mentor_mentoring_about2.webp';
import MentoringAboutSource3 from 'assets/images/pages/programAbout/mentor_mentoring_about3.webp';
import MentoringAboutSource4 from 'assets/images/pages/programAbout/mentor_mentoring_about4.webp';

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const MentorMentoringAbout = () => {
  return (
    <>
      <div
        style={{
          maxWidth: `${CWindowWidth - 300}px`,
          margin: '80px auto',
          padding: '0px 10px',
        }}
      >
        <Title style={{ marginBottom: '30px' }}>멘토링 방식</Title>
        <Row align='middle' gutter={[32, 16]} justify='space-between' style={{ marginBottom: '120px' }}>
          <Col
            xs={{ span: 24, order: 2 }}
            sm={{ span: 24, order: 2 }}
            md={{ span: 12, order: 1 }}
            lg={{ span: 12, order: 1 }}
            xl={{ span: 12, order: 1 }}
          >
            <ScrollAnimation animateIn='fadeInLeft' animateOnce={true} duration={1.5}>
              <Avatar shape='square' src={MentoringAboutSource1} style={{ height: 'auto', width: '100%' }} />
            </ScrollAnimation>
          </Col>
          <Col
            xs={{ span: 24, order: 1 }}
            sm={{ span: 24, order: 1 }}
            md={{ span: 12, order: 2 }}
            lg={{ span: 12, order: 2 }}
            xl={{ span: 12, order: 2 }}
          >
            <p className='step-info step-right'>
              <span className='step'>STEP 1 </span>
              <Title level={2}>멘티의 멘토링 신청 수락하기</Title>
              <List split={false}>
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='나의 멘토링 관리’에서 수락 대기 중인 멘토링 신청을 수락해주세요.'
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='혹시 시간 변경이 필요한 경우, 거절을 누르고 취소 사유에 새로운 시간을 제안해주세요.'
                />
              </List>
            </p>
          </Col>
        </Row>
        <Row align='middle' gutter={[32, 16]} justify='space-between' style={{ marginBottom: '120px' }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <p className='step-info step-left'>
              <span className='step'>STEP 2 </span>
              <Title level={2}>멘토링 링크 접속</Title>
              <List split={false}>
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description="'나의 멘토링 관리'에서 예정된 멘토링을 확인하세요."
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description="'자세히 보기'를 클릭해서 오늘 멘토링 내용을 미리 확인하세요."
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description="'자세히 보기' 내 우측 멘티 프로필 카드 아래 '멘토링 참여하기' 버튼을 누르세요."
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description={
                    <span>
                      멘토링은 Zoom을 통해 화상으로 진행됩니다.
                      <br />(
                      <a target='_blank' rel='noopener noreferrer' href='https://zoom.us/download'>
                        Zoom 다운로드하기
                      </a>
                      )
                    </span>
                  }
                />
              </List>
            </p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <ScrollAnimation animateIn='fadeInRight' animateOnce={true} duration={1.5}>
              <Avatar shape='square' src={MentoringAboutSource2} style={{ height: 'auto', width: '100%' }} />
            </ScrollAnimation>
          </Col>
        </Row>
        <Row align='middle' gutter={[32, 16]} justify='space-between' style={{ marginBottom: '120px' }}>
          <Col
            xs={{ span: 24, order: 2 }}
            sm={{ span: 24, order: 2 }}
            md={{ span: 12, order: 1 }}
            lg={{ span: 12, order: 1 }}
            xl={{ span: 12, order: 1 }}
          >
            <ScrollAnimation animateIn='fadeInLeft' animateOnce={true} duration={1.5}>
              <Avatar shape='square' src={MentoringAboutSource3} style={{ height: 'auto', width: '100%' }} />
            </ScrollAnimation>
          </Col>
          <Col
            xs={{ span: 24, order: 1 }}
            sm={{ span: 24, order: 1 }}
            md={{ span: 12, order: 2 }}
            lg={{ span: 12, order: 2 }}
            xl={{ span: 12, order: 2 }}
          >
            <p className='step-info step-right'>
              <span className='step'>STEP 3 </span>
              <Title level={2}>멘토링 진행하기</Title>
              <List split={false}>
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='카메라와 인터넷 연결을 확인하시고, 화상회의 세션에서 멘티를 만나세요.'
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='사전에 멘티가 전달한 희망 토픽 및 요청사항에 따라 멘티와 멘토링을 진행하세요.'
                />
              </List>
            </p>
          </Col>
        </Row>
        <Row align='middle' gutter={[32, 16]} justify='space-between' style={{ marginBottom: '150px' }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <p className='step-info step-left'>
              <span className='step'>STEP 4 </span>
              <Title level={2}>멘티 피드백 하기</Title>
              <List split={false}>
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='멘토링 종료 후 ‘나의 멘토링 관리’에서 멘티의 성장을 위해 세심하게 피드백을 작성해주세요.'
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='‘나의 멘토링 관리’에서 멘티가 나에게 준 피드백도 확인할 수 있습니다.'
                />
              </List>
            </p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <ScrollAnimation animateIn='fadeInRight' animateOnce={true} duration={1.5}>
              <Avatar shape='square' src={MentoringAboutSource4} style={{ height: 'auto', width: '100%' }} />
            </ScrollAnimation>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default MentorMentoringAbout;
